module.exports = __webpack_public_path__ + "static/media/makeup_female.55fab3f2.svg";